// Sprichwörter – zufällig kombinierbare, grammatikalisch kompatible Hälften

export const sprichwoerterGroups = [
    {
        // Pattern: [Adjective] Martha [Verbphrase]
        id: 'pattern1',
        firstHalves: [
            'Die frühe Martha',
            'Die fleißige Martha',
            'Die kluge Martha',
            'Die geduldige Martha',
            'Die vorsichtige Martha'
        ],
        secondHalves: [
            'fängt den Wurm',
            'spart in der Zeit',
            'weiß sich zu helfen',
            'kommt ans Ziel',
            'geht keinen falschen Weg'
        ]
    },
    {
        // Pattern: Martha [Verb] [Result/Consequence]
        id: 'pattern2',
        firstHalves: [
            'Martha kommt',
            'Martha macht',
            'Martha gibt',
            'Martha nimmt',
            'Martha bringt'
        ],
        secondHalves: [
            'nicht allein',
            'die Dinge ins Rollen',
            'mehr, als man erwartet',
            'was sie braucht',
            'Glück ins Haus'
        ]
    },
    {
        // Pattern: Conditional / Relative clause
        id: 'pattern3',
        firstHalves: [
            'Wenn Martha sät',
            'Wer Martha kennt',
            'Wenn Martha ruft',
            'Was Martha nicht weiß',
            'Wie Martha sich bettet'
        ],
        secondHalves: [
            'wird später ernten',
            'weiß, woran er ist',
            'der bleibt nicht fern',
            'macht sie nicht heiß',
            'so liegt sie auch'
        ]
    },
    {
        // Pattern: Prepositional phrase
        id: 'pattern4',
        firstHalves: [
            'Mit Martha',
            'Ohne Martha',
            'Bei Martha',
            'Durch Martha',
            'Für Martha'
        ],
        secondHalves: [
            'ist gut Kirschen essen',
            'geht es nur halb so gut',
            'fühlt man sich daheim',
            'findet man einen Weg',
            'ist keine Mühe zu groß'
        ]
    },
    {
        // Pattern: Metaphor / Comparison
        id: 'pattern5',
        firstHalves: [
            'Martha ist wie Gold',
            'Martha in der Hand',
            'Martha auf dem Weg',
            'Martha in der Not',
            'Martha am Morgen'
        ],
        secondHalves: [
            'das glänzt und bleibt',
            'ist besser als ein Versprechen',
            'kommt sicher ans Ziel',
            'zeigt ihren wahren Wert',
            'vertreibt Kummer und Sorgen'
        ]
    },
    {
        // Pattern: Present participle + consequence
        id: 'pattern6',
        firstHalves: [
            'Lachende Martha',
            'Fleißige Martha',
            'Ruhige Martha',
            'Wachsame Martha',
            'Schlafende Martha'
        ],
        secondHalves: [
            'trägt die Sonne im Herzen',
            'kommt weit im Leben',
            'bewahrt den Überblick',
            'verpasst keine Gelegenheit',
            'soll man nicht wecken'
        ]
    }
];


// Helper function to get random element from array
export const getRandomElement = (array) => {
  return array[Math.floor(Math.random() * array.length)];
};

// Helper function to get random group
export const getRandomGroup = () => {
  return getRandomElement(sprichwoerterGroups);
};

